import React from "react";
import { OtpInput } from "@/components";
import { FormatTime } from "@/lib/constants";
import { QueryBuilder } from "@mui/icons-material";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

function VerifyOtpModalFields({
  formik,
  timeLeft,
  resetTimer,
  generateOtp,
  otpVerifying,
  handleOtpSubmit,
  verificationFailedReason,
}) {
  const t = useTranslations("Login");
  return (
    <Stack spacing={3}>
      <Typography display={"block"} textAlign={"center"}>
        Please enter the OTP code sent to
      </Typography>

      {formik.values.phone ? (
        <Typography
          variant="span"
          sx={{
            display: "block",
            textAlign: "center",
            color: "#093",
          }}
        >
          +91 {formik.values.phone}
        </Typography>
      ) : (
        <Typography fontWeight={700}>{t("regmobile")}</Typography>
      )}
      <OtpInput
        length={4}
        onOtpSubmit={handleOtpSubmit}
        isLoading={otpVerifying}
      />
      {verificationFailedReason?.data?.message && (
        <Typography sx={{ color: "#d32f2f" }} align="center">
          {verificationFailedReason?.data?.message}
        </Typography>
      )}
      <Stack
        spacing={1}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {timeLeft !== 0 ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            px={1}
            spacing={1}
          >
            <Typography variant="span">{t("didntgetotp")}</Typography>
            <Stack
              direction={"row"}
              spacing={0.5}
              alignItems={"center"}
              color={"red"}
            >
              <QueryBuilder fontSize="14" />
              <Typography align="center" minWidth={40} maxWidth={40}>
                {FormatTime(timeLeft)}
              </Typography>
            </Stack>
          </Stack>
        ) : (
          <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
            <Typography variant="span">{t("didntgetotp")}</Typography>
            <Tooltip title="Resend an OTP for the above mobile number">
              <Button
                sx={{ ml: 1, textDecoration: "underline", fontWeight: "bold" }}
                onClick={() => {
                  resetTimer();
                  generateOtp({ phone: formik?.values?.phone });
                }}
              >
                {t("resendotp")}
              </Button>
            </Tooltip>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}

export default VerifyOtpModalFields;
